import styled from "styled-components"

import { ReactComponent as IconClock } from "assets/svg/clock.svg"

import { useCustomerDashboard } from "../CustomerDashboardContext"

const Container = styled.div<{ sidebarOpen?: boolean }>`
  margin-top: 2px;
  padding: 23px ${({ sidebarOpen }) => (sidebarOpen ? "24px" : "0")} 20px 0;
  max-height: calc(100dvh - 255px);
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100dvh - 300px);
`

const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  transform: translateY(-50px);
`

const IconWrapper = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`

const StyledClockIcon = styled(IconClock)`
  width: 24px;
  height: 24px;
`

const Title = styled.h2`
  font-size: 16px;
  font-weight: 400;
  color: #0f172a;
  margin: 0 0 12px 0;
`

const Subtitle = styled.p`
  font-size: 14px;
  font-weight: 300;
  color: #64748b;
  margin: 0;
  max-width: 400px;
  line-height: 1.5;
`

interface ComingSoonSectionProps {
  title: string
  subtitle: string
}

export const ComingSoonSection = ({ title, subtitle }: ComingSoonSectionProps) => {
  const { isSidebarOpen } = useCustomerDashboard()

  return (
    <Container sidebarOpen={isSidebarOpen}>
      <CenteredContent>
        <IconWrapper>
          <StyledClockIcon />
        </IconWrapper>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </CenteredContent>
    </Container>
  )
}
